import { observer } from 'mobx-react-lite';
import useJoinPwdSettingView from '../useJoinPwdSettingView';
import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH_FOR_COMPLETE } from '@/consts';
import clsx from 'clsx';

interface IProps {
  onClick: () => void;
}

const JoinPwdSettingView = observer(({ onClick }: IProps) => {
  const {
    password,
    checkPassword,
    isCompleteBtnDisabled,
    isPasswordValid,
    onChangePassword,
    onChangeCheckPassword,
    onClickCompleteBtn,
    onBlurPassword,
    onKeyDownCheckPassword,
  } = useJoinPwdSettingView(onClick);

  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="password-title heading-4 font-bold">비밀번호 설정</h1>

        <form className="password-form">
          <div className="form-group">
            <label htmlFor="password" className="form-label text-base font-medium">
              비밀번호를 입력해주세요
            </label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="영문, 숫자, 특수문자 포함 8~20자 입력"
              className="form-input"
              value={password}
              maxLength={MAX_PASSWORD_LENGTH}
              onChange={onChangePassword}
              onBlur={onBlurPassword}
            />

            {!isPasswordValid && (
              <p className="error-message phone-error text-sm font-normal">비밀번호가 잘못 입력되었습니다.</p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="password-confirm" className="form-label text-base font-medium">
              비밀번호를 다시 입력해주세요
            </label>
            <input
              type="password"
              id="password-confirm"
              name="password-confirm"
              placeholder="비밀번호 확인"
              className="form-input"
              value={checkPassword}
              maxLength={MAX_PASSWORD_LENGTH}
              onChange={onChangeCheckPassword}
              onBlur={onBlurPassword}
              onKeyDown={onKeyDownCheckPassword}
            />

            {password !== checkPassword &&
              password &&
              password.length >= MIN_PASSWORD_LENGTH_FOR_COMPLETE &&
              checkPassword.length >= 1 && (
                <p className="error-message phone-error text-sm font-normal">비밀번호가 일치하지 않습니다.</p>
              )}
          </div>

          <button
            type="button"
            className={clsx('btn-primary signup-button text-lg font-semibold', {
              active: !isCompleteBtnDisabled,
              default_cursor: isCompleteBtnDisabled,
            })}
            disabled={isCompleteBtnDisabled}
            onClick={onClickCompleteBtn}
            id="nextBtn"
          >
            다음
          </button>
        </form>
      </div>
    </div>
  );
});

export default JoinPwdSettingView;
